// Utility per gestire endpoint in base all'ambiente
export const getEndpoint = (endpointType: string): string => {
  const isProduction = process.env.NODE_ENV === 'production';
  
  switch (endpointType) {
    case 'LOGIN':
      return isProduction 
        ? process.env.REACT_APP_PROD_LOGIN_ENDPOINT! 
        : process.env.REACT_APP_LOGIN_ENDPOINT!;
    
    case 'BACKEND':
      return isProduction 
        ? process.env.REACT_APP_PROD_BACKEND_ENDPOINT! 
        : process.env.REACT_APP_BACKEND_ENDPOINT!;
    
    case 'GLOSS':
      return isProduction 
        ? process.env.REACT_APP_PROD_BACKEND_ENDPOINT_GLOSS! 
        : process.env.REACT_APP_BACKEND_ENDPOINT_GLOSS!;
    
    case 'TRANSLATE':
      return isProduction 
        ? process.env.REACT_APP_PROD_TRANSLATE_ENDPOINT! 
        : process.env.REACT_APP_TRANSLATE_ENDPOINT!;
    
    case 'MEMORY':
      return isProduction 
        ? process.env.REACT_APP_PROD_BACKEND_ENDPOINT_MEMORY!
        : process.env.REACT_APP_BACKEND_ENDPOINT_MEMORY!; 
    
    
    case 'SIMILARITY':
      return process.env.REACT_APP_SIMILARITY_ENDPOINT!; 
    
    default:
      throw new Error(`Unknown endpoint type: ${endpointType}`);
  }
};

// Log dell'ambiente per debugging
export const logEnvironment = () => {
  console.log('Using endpoints:', {
    LOGIN: getEndpoint('LOGIN'),
    BACKEND: getEndpoint('BACKEND'),
    GLOSS: getEndpoint('GLOSS'),
    TRANSLATE: getEndpoint('TRANSLATE'),
  });
};
